import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import plugin from './plugins/index'
import './plugins/element.js'
import './assets/css/common.css'
import './assets/icon/iconfont.css'

Vue.config.productionTip = false
Vue.use(plugin)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
